@use '@snowit/style/mixins';

.container {
  position: fixed;
  right: 0;
  bottom: var(--s-df);
  left: 0;
  z-index: var(--z-index-top);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
}

// Open position
@include mixins.media(sm) {
  .topLeft {
    top: var(--s-inset);
    right: initial;
    bottom: initial;
    left: var(--s-inset);
  }

  .topRight {
    top: var(--s-inset);
    right: var(--s-inset);
    bottom: initial;
    left: initial;
  }

  .bottomLeft {
    right: initial;
    bottom: var(--s-inset);
    left: var(--s-inset);
  }

  .bottomRight {
    right: var(--s-inset);
    bottom: var(--s-inset);
    left: initial;
  }
}

// Wrapper
.wrapper {
  --lc-bg: var(--c-info-l);
  --lc-bg-icon: var(--c-info);
  --lc-icon: var(--c-white);

  display: grid;
  grid-template-columns: 2rem 1fr;
  column-gap: 0.75rem;
  width: calc(100% - (var(--s-inset) * 2));
  min-height: 3rem;
  padding: 1rem 1rem 1rem 0.75rem;
  border-radius: var(--s-xxs);
  background-color: var(--lc-bg);
  box-shadow: var(--sw-dp8);

  @include mixins.media(sm) {
    width: 100%;
    max-width: 25rem;
  }
}

// Icon
.wrapIcon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: var(--s-uxs);
  background-color: var(--lc-bg-icon);
  cursor: pointer;
}

.icon {
  --lw-icon: 1rem;

  width: var(--lw-icon);
  height: var(--lw-icon);
  fill: var(--lc-icon);
}

// Text
.wrapText {
  display: flex;
  flex-direction: column;
  gap: var(--s-uxs);
  cursor: pointer;
}

// Close
.close {
  --lw-icon: 1rem;

  width: var(--lw-icon);
  height: var(--lw-icon);
  fill: var(--c-text);
  cursor: pointer;
}

// If hasClose
.hasClose {
  grid-template-columns: 2rem 1fr 1rem;
  padding: 1rem 0.75rem;
}

// If theme "ok"
.ok {
  --lc-bg: var(--c-ok-l);
  --lc-bg-icon: var(--c-ok);
}

// If theme "warning"
.warning {
  --lc-bg: var(--c-warning-l);
  --lc-bg-icon: var(--c-warning-amber);
}

// If theme "error"
.error {
  --lc-bg: var(--c-error-l);
  --lc-bg-icon: var(--c-error);
}

// If theme 'marketing'
.marketing {
  --lc-bg: var(--c-white);
  --lc-bg-icon: var(--c-primary-l2);
  --lc-icon: var(--c-primary);

  .wrapIcon {
    border-radius: 50%;
  }
}
